<template>
  <div class="plat-student-info">
    <PlatStudentInfoDashboard :student-id="rowData.id"
                              v-bind="$attrs"
                              v-on="$listeners"></PlatStudentInfoDashboard>
  </div>
</template>

<script>
import PlatStudentInfoDashboard from './dashboard'
export default {
  name: 'PlatStudentInfo',
  components: {
    PlatStudentInfoDashboard
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .plat-student-info {
    height: 100%;
  }
</style>
